export default __webpack_public_path__ + "static/media/about-2.fee12abe.jpg";